import Swiper from 'swiper/swiper-bundle.min.js';
const MicroModal = require('micromodal');
//import { listen, prefetch } from 'quicklink';
global.jQuery = global.$ = window.jQuery = require('jquery');

// quicklink
// listen({
//   origins: [
//     'www.tacthome.co.jp',
//     'lmp-stg.work'
//   ],
//   ignores: [
//     /\/api\/?/,
//     /#(.+)/,
//     /tel:(.+)/,
//     /mailto:(.+)/,
//     uri => uri.includes('.zip'),
//     (uri, elem) => elem.hasAttribute('noprefetch')
//   ]
// });

// グローバルナビ
const gnav = document.getElementById('panel-gnav');

// メガメニュー
const gnavCtrl = document.querySelectorAll('.js-menu-ctrl');
const gnavItem = document.querySelectorAll('.p-gnav__item');
const gnavPanel = document.querySelectorAll('.p-gnav__menu');

// ハンバーガーメニュー
const burger = document.getElementById('burger');

if(burger !== null){
  burger.addEventListener('click', (e) => {
    if (burger.getAttribute('aria-expanded') == 'false') {
      [].forEach.call(gnavPanel, (ctrl) => {
        ctrl.setAttribute('aria-hidden', false);
      });
      burger.setAttribute('aria-expanded', true);
      gnav.setAttribute('aria-hidden', false);
      document.documentElement.classList.add('fixed');
    } else {
      [].forEach.call(gnavPanel, (ctrl) => {
        ctrl.setAttribute('aria-hidden', true);
      });
      burger.setAttribute('aria-expanded', false);
      gnav.setAttribute('aria-hidden', true);
      document.documentElement.classList.remove('fixed');
    }
  });
}

// 絞り込み条件開閉ボタン
const filterCtrl = document.querySelectorAll('.p-search-filter__btn');

// エリアマップ
const mapArea = document.querySelectorAll('.p-search-top__area > li > a');
const mapPref = document.querySelectorAll('.p-search-top__pref > li > a');
const mapPath =  document.querySelectorAll('.p-search-top__map path');
const areaOver = (target) => {
  [].forEach.call(document.querySelectorAll('path[data-area="' + target.getAttribute('data-area') + '"]'), (area) => {
    area.classList.add('active');
  });
};
const prefOver = (target) => {
  document.getElementById(target.getAttribute('data-pref')).classList.add('active');
};
const areaLeave = () => {
  [].forEach.call(mapPath, (map) => {
    map.classList.remove('active');
  });
};

// タブ
const tabs = document.querySelectorAll('[role="tablist"] [role="tab"]');
const tabpanels = document.querySelectorAll('[role="tabpanel"]');

[].forEach.call(tabs, (ctrl) => {
  ctrl.addEventListener('click', (e) =>{
    const target = e.currentTarget;

    [].forEach.call(tabs, (tab) => {
      tab.setAttribute("aria-selected", false);
    });

    target.setAttribute("aria-selected", true);

    [].forEach.call(tabpanels, (panel) => {
      panel.setAttribute("aria-hidden", true);
    });

    document.getElementById(target.getAttribute('aria-controls')).setAttribute('aria-hidden', false);

  });
});

//media query
// const mediaQuerySm = window.matchMedia('(min-width: 640px)');
const mediaQueryMd = window.matchMedia('(min-width: 768px)');
const mediaQueryLg = window.matchMedia('(min-width: 1024px)');
// const mediaQueryXl = window.matchMedia('(min-width: 1280px)');


// const mediaQuerySmListner = (mq) => {
//   if (mq.matches) { // 640px以上

//   } else { // 640px未満

//   }
// };

const mediaQueryMdListner = (mq) => {
  if (mq.matches) { // 768px以上
    // グローバルナビ
    if(gnav !== null) {
      gnav.setAttribute('aria-hidden', false);
      for (let i = 0; i < gnavCtrl.length; i++) {
        gnavCtrl[i].setAttribute('aria-expanded', false);
        gnavCtrl[i].style.display = 'block';
      }
    }

    // メガメニュー
    [].forEach.call(gnavPanel, (ctrl) => {
      ctrl.setAttribute('aria-hidden', true);
    });
    [].forEach.call(gnavItem, (ctrl) => {
      if(ctrl.querySelector('.js-menu-ctrl') !== null){
        ctrl.querySelector('.js-menu-ctrl').setAttribute('aria-expanded', false);
        ctrl.addEventListener('mouseenter', (e) => {
          for (let i = 0; i < gnavCtrl.length; i++) {
            gnavCtrl[i].setAttribute('aria-expanded', false);
          }
          for (let i = 0; i < gnavPanel.length; i++) {
            gnavPanel[i].setAttribute('aria-hidden', true);
          }
          const targetPanel = e.currentTarget.querySelector('.js-menu-ctrl').getAttribute('aria-controls');
          e.currentTarget.querySelector('.js-menu-ctrl').setAttribute('aria-expanded', true);
          document.getElementById(targetPanel).setAttribute('aria-hidden', false);
        });
        ctrl.addEventListener('mouseleave', (e) => {
          for (let i = 0; i < gnavCtrl.length; i++) {
            gnavCtrl[i].setAttribute('aria-expanded', false);
          }
          for (let i = 0; i < gnavPanel.length; i++) {
            gnavPanel[i].setAttribute('aria-hidden', true);
          }
        });
      }
    });

    // 絞り込み条件開閉ボタン
    [].forEach.call(filterCtrl, (ctrl) => {
      const targetPanel = ctrl.getAttribute('aria-controls');
      ctrl.setAttribute('aria-expanded', true);
      ctrl.setAttribute('aria-label', '絞り込み条件のタブを閉じる');
      document.getElementById(targetPanel).setAttribute('aria-hidden', false);
    });

  } else { // 768px未満
    // グローバルナビ
    if(gnav !== null){
      gnav.setAttribute('aria-hidden', true);
      for (let i = 0; i < gnavCtrl.length; i++) {
        gnavCtrl[i].setAttribute('aria-expanded', false);
        gnavCtrl[i].style.display = 'none';
      }
    }

    // 絞り込み条件開閉ボタン
    [].forEach.call(filterCtrl, (ctrl) => {
      const targetPanel = ctrl.getAttribute('aria-controls');
      ctrl.setAttribute('aria-expanded', false);
      ctrl.setAttribute('aria-label', '絞り込み条件のタブを開く');
      document.getElementById(targetPanel).setAttribute('aria-hidden', true);
    });

  }
};

const mediaQueryLgListner = (mq) => {
  if (mq.matches) { // 1024px以上
    [].forEach.call(mapArea, (area) => {
      area.addEventListener('mouseover', (e) => {
        areaOver(e.currentTarget);
      });
      area.addEventListener('mouseleave', (e) => {
        areaLeave();
      });
    });
    [].forEach.call(mapPref, (pref) => {
      pref.addEventListener('mouseover', (e) => {
        prefOver(e.currentTarget);
      });
      pref.addEventListener('mouseleave', (e) => {
        areaLeave();
      });
    });
  } else { // 1024px未満
    // トップページの場合タブパネル初期化
    const pathname = location.pathname.replace(/index.html|index.php/g, '');
    if(pathname == '/grafaresearch/'){
      [].forEach.call(tabs, (tab) => {
        tab.setAttribute("aria-selected", false);
      });
      document.querySelector('[aria-controls="panel-area"]').setAttribute("aria-selected", true);
      [].forEach.call(tabpanels, (panel) => {
        panel.setAttribute("aria-hidden", true);
      });
      document.getElementById('panel-area').setAttribute('aria-hidden', false);
    }
  }
};

// const mediaQueryXlListner = (mq) => {
//   if (mq.matches) { // 1280px以上

//   } else { // 1280px未満

//   }
// };

// mediaQuerySm.addEventListener("change", mediaQuerySmListner);
mediaQueryMd.addEventListener("change", mediaQueryMdListner);
mediaQueryLg.addEventListener("change", mediaQueryLgListner);
// mediaQueryXl.addEventListener("change", mediaQueryXlListner);

// mediaQuerySmListner(mediaQuerySm);
mediaQueryMdListner(mediaQueryMd);
mediaQueryLgListner(mediaQueryLg);
// mediaQueryXlListner(mediaQueryXl);

// 物件カルーセル
const swiperContainer = document.querySelectorAll('.js-swiper-card');
const prevSlideMessage = '前のスライドへ';
const nextSlideMessage = '次のスライドへ';
if(swiperContainer.length > 0) {
  const swiperCard = new Swiper ('.js-swiper-card', {
    slidesPerView: 'auto',
    spaceBetween: 24,
    grabCursor: true,
    navigation: {
      nextEl: '.js-swiper-card .swiper-button-next',
      prevEl: '.js-swiper-card .swiper-button-prev',
    },
    a11y: {
      prevSlideMessage: prevSlideMessage,
      nextSlideMessage: nextSlideMessage,
    },
    breakpoints: {
      768: {
        spaceBetween: 32,
      }
    },
  });
}

// お気に入りボタン
const favoriteBtn = document.querySelectorAll('.js-favorite');
[].forEach.call(favoriteBtn, (btn) => {
  btn.addEventListener('click', (e) => {
    if(e.currentTarget.classList.contains("added")){
      e.currentTarget.classList.remove('added');
      e.currentTarget.setAttribute('aria-label', 'お気に入りに追加');
      e.currentTarget.innerHTML = '<span>お気に入りに追加</span>';
    }else{
      e.currentTarget.classList.add('added');
      e.currentTarget.setAttribute('aria-label', 'お気に入りから削除');
      e.currentTarget.innerHTML = '<span>お気に入りから削除</span>';
    }
  });
});

// 物件チェックボタン
const propertyAllCheckBtn = document.querySelectorAll('.js-property-allcheck');
const propertyCheckBtn = document.querySelectorAll('.js-property-check');
const propertyCtaFixed = document.querySelector('.js-cta-fixed.p-property-cta-fixed');
const propertyCtaRequest = document.querySelector('.js-cta-request');
const propertyCtaResult = document.querySelector('.js-cta-result');

[].forEach.call(propertyAllCheckBtn, (btn) => {
  btn.addEventListener('click', (e) => {
    const checked = e.currentTarget.checked;
    if(checked){
      for (let i = 0; i < propertyAllCheckBtn.length; i++) {
        propertyAllCheckBtn[i].checked = true;
      }
      for (let i = 0; i < propertyCheckBtn.length; i++) {
        propertyCheckBtn[i].checked = true;
      }
      if(propertyCtaResult !== null) propertyCtaResult.classList.remove('visible');
      if(propertyCtaRequest !== null) propertyCtaRequest.classList.add('visible');
      if(propertyCtaFixed !== null) propertyCtaFixed.classList.add('visible');
    }else{
      for (let i = 0; i < propertyAllCheckBtn.length; i++) {
        propertyAllCheckBtn[i].checked = false;
      }
      for (let i = 0; i < propertyCheckBtn.length; i++) {
        propertyCheckBtn[i].checked = false;
      }
      if(propertyCtaResult !== null) propertyCtaResult.classList.remove('visible');
      if(propertyCtaRequest !== null) propertyCtaRequest.classList.remove('visible');
      if(propertyCtaFixed !== null) propertyCtaFixed.classList.remove('visible');
    }
  });
});

[].forEach.call(propertyCheckBtn, (btn) => {
  btn.addEventListener('click', (e) => {
    const checkedBtns = document.querySelectorAll('.js-property-check:checked');
    if(checkedBtns.length > 0){
      if(checkedBtns.length == propertyCheckBtn.length){
        for (let i = 0; i < propertyAllCheckBtn.length; i++) {
          propertyAllCheckBtn[i].checked = true;
        }
      }else{
        for (let i = 0; i < propertyAllCheckBtn.length; i++) {
          propertyAllCheckBtn[i].checked = false;
        }
      }
      if(propertyCtaResult !== null) propertyCtaResult.classList.remove('visible');
      if(propertyCtaRequest !== null) propertyCtaRequest.classList.add('visible');
      if(propertyCtaFixed !== null) propertyCtaFixed.classList.add('visible');
    }else{
      for (let i = 0; i < propertyAllCheckBtn.length; i++) {
        propertyAllCheckBtn[i].checked = false;
      }
      if(propertyCtaResult !== null) propertyCtaResult.classList.remove('visible');
      if(propertyCtaRequest !== null) propertyCtaRequest.classList.remove('visible');
      if(propertyCtaFixed !== null) propertyCtaFixed.classList.remove('visible');
    }
  });
});

// 市区町村、沿線・駅チェックボタン
const checkCtrl = document.querySelectorAll('[data-check-ctrl]');
const checkTarget = document.querySelectorAll('[data-check-target]');

[].forEach.call(checkCtrl, (ctrl) => {
  ctrl.addEventListener('click', (e) => {
    const checkedCtrl = document.querySelectorAll('[data-check-ctrl]:checked');
    const targetName = e.currentTarget.getAttribute('data-check-ctrl')
    const target = document.querySelectorAll('[data-check-target="' + targetName + '"]');
    const checked = e.currentTarget.checked;
    for (let i = 0; i < target.length; i++) {
      if(checked){
        target[i].checked = true;
      }else{
        target[i].checked = false;
      }
    }
    if(propertyCtaFixed !== null && e.currentTarget.closest('.p-modal') === null){
      if(checkedCtrl.length > 0){
        if(propertyCtaResult !== null) propertyCtaResult.classList.add('visible');
        if(propertyCtaRequest !== null) propertyCtaRequest.classList.remove('visible');
        propertyCtaFixed.classList.add('visible');
      }else{
        if(propertyCtaResult !== null) propertyCtaResult.classList.remove('visible');
        if(propertyCtaRequest !== null) propertyCtaRequest.classList.remove('visible');
        propertyCtaFixed.classList.remove('visible');
      }
    }
  });
});

[].forEach.call(checkTarget, (ctrl) => {
  ctrl.addEventListener('click', (e) => {
    const propertyCheckedBtn = document.querySelectorAll('.js-property-check:checked');
    const targetName = e.currentTarget.getAttribute('data-check-target')
    const target = document.querySelectorAll('[data-check-ctrl="' + targetName + '"]');
    const checkBtns = document.querySelectorAll('[data-check-target="' + targetName + '"]');
    const checkedBtns = document.querySelectorAll('[data-check-target="' + targetName + '"]:checked');
    if(checkedBtns.length > 0){
      if(checkedBtns.length == checkBtns.length){
        for (let i = 0; i < target.length; i++) {
          target[i].checked = true;
        }
      }else{
        for (let i = 0; i < target.length; i++) {
          target[i].checked = false;
        }
      }
      if(propertyCtaFixed !== null && e.currentTarget.closest('.p-modal') === null){
        if(propertyCtaResult !== null) propertyCtaResult.classList.add('visible');
        if(propertyCtaRequest !== null) propertyCtaRequest.classList.remove('visible');
        propertyCtaFixed.classList.add('visible');
      }
    }else{
      for (let i = 0; i < target.length; i++) {
        target[i].checked = false;
      }
      if(propertyCtaResult !== null) propertyCtaResult.classList.remove('visible');
      if(propertyCtaRequest !== null) propertyCtaRequest.classList.remove('visible');
      if(propertyCtaFixed !== null) propertyCtaFixed.classList.remove('visible');
    }
  });
});

// アコーディオン
const acdCtrl = document.querySelectorAll('.js-accrodion');
[].forEach.call(acdCtrl, (ctrl) => {
  ctrl.addEventListener('click', (e) => {
    const targetPanel = e.currentTarget.getAttribute('aria-controls');
    const state = e.currentTarget.getAttribute('aria-expanded');
    if(state == 'false'){
      e.currentTarget.setAttribute('aria-expanded', true);
      e.currentTarget.setAttribute('aria-label', 'タブを閉じる');
      document.getElementById(targetPanel).setAttribute('aria-hidden', false);
    }else{
      e.currentTarget.setAttribute('aria-expanded', false);
      e.currentTarget.setAttribute('aria-label', 'タブを開く');
      document.getElementById(targetPanel).setAttribute('aria-hidden', true);
    }
  });
});

// 条件追加ボタン
const moreCtrl = document.querySelectorAll('.js-more');
[].forEach.call(moreCtrl, (ctrl) => {
  ctrl.addEventListener('click', (e) => {
    const targetPanel = e.currentTarget.getAttribute('aria-controls');
    const state = e.currentTarget.getAttribute('aria-expanded');
    if(state == 'false'){
      e.currentTarget.setAttribute('aria-expanded', true);
      e.currentTarget.setAttribute('aria-label', 'タブを閉じる');
      document.getElementById(targetPanel).setAttribute('aria-hidden', false);
      e.currentTarget.style.display = 'none';
    }else{
      e.currentTarget.setAttribute('aria-expanded', false);
      e.currentTarget.setAttribute('aria-label', 'タブを開く');
      document.getElementById(targetPanel).setAttribute('aria-hidden', true);
    }
  });
});

//検索モーダル内コンテンツ表示制御
const modalNextCtrl = document.querySelectorAll('.js-modal-next');
const modalbackCtrl = document.querySelectorAll('.js-modal-prev');
[].forEach.call(modalNextCtrl, (ctrl) => {
  ctrl.addEventListener('click', (e) => {
    const parentElem = e.currentTarget.closest('.p-search');
    const nextElem = parentElem.nextElementSibling;
    parentElem.classList.remove('visible')
    nextElem.classList.add('visible')
  });
});
[].forEach.call(modalbackCtrl, (ctrl) => {
  ctrl.addEventListener('click', (e) => {
    const parentElem = e.currentTarget.closest('.p-search');
    const prevElem = parentElem.previousElementSibling;
    parentElem.classList.remove('visible')
    prevElem.classList.add('visible')
  });
});

// 検索モーダルオープン時初期化
window.openModalContents = (target) => {
  const modalContents = document.getElementById(target);
  const allModalContents = document.querySelectorAll('.p-modal .p-search');
  [].forEach.call(allModalContents, (elm) => {
    elm.classList.remove('visible');
  });
	if(modalContents !== null) modalContents.classList.add('visible');
}

// 物件詳細スライド
window.initMainSlide = () =>{
  const swiperMainContainer = document.querySelector('.js-swiper-main');
  // const swiperThumbContainer = document.querySelector('.js-swiper-thumb');
  if(swiperMainContainer !== null) {
  // if(swiperMainContainer !== null && swiperThumbContainer !== null) {
    // const swiperThumb = new Swiper ('.js-swiper-thumb', {
    //   loop: true,
    //   slidesPerView: 'auto',
    //   spaceBetween: 8,
    //   watchSlidesProgress: true,
    //   slideToClickedSlide: true,
    //   centeredSlides: false,
    //   breakpoints: {
    //     768: {
    //       spaceBetween: 16,
    //       centeredSlides: true,
    //     }
    //   }
    // });

    const swiperMain = new Swiper ('.js-swiper-main', {
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 0,
      centeredSlides: true,
      navigation: {
        nextEl: ".js-swiper-main .swiper-button-next",
        prevEl: ".js-swiper-main .swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        type: "fraction",
      },
      breakpoints: {
        768: {
          spaceBetween: 16,
        }
      }
    });

    // swiperMain.controller.control = swiperThumb;
    // swiperThumb.controller.control = swiperMain;

  }
};

// 物件詳細CTA
const propertyDetailCtaFixed = document.querySelector('.js-cta-fixed.p-property-detail__cta-fixed');
const visibleTargat = document.querySelector('.js-visible-cta');
// const hideTarget = document.querySelector('.js-hide-cta');
window.dispPropertyDetailCta = () => {
  // if(propertyDetailCtaFixed !== null && visibleTargat !== null && hideTarget !== null){
  if(propertyDetailCtaFixed !== null && visibleTargat !== null){
    let scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset: document.documentElement.scrollTop;
    let visibleTargetBottom = visibleTargat.getBoundingClientRect().top + visibleTargat.clientHeight + scrollTop;
    // let hideTargetTop = hideTarget.getBoundingClientRect().top + scrollTop;
    // let hideTargetBottom = hideTarget.getBoundingClientRect().top + hideTarget.clientHeight + scrollTop;
    // if((scrollTop > visibleTargetBottom && scrollTop < hideTargetTop - window.innerHeight) || (scrollTop > hideTargetBottom)){
    //   propertyDetailCtaFixed.classList.add('visible');
    // }else{
    //   propertyDetailCtaFixed.classList.remove('visible');
    // }
    if(scrollTop > visibleTargetBottom){
      propertyDetailCtaFixed.classList.add('visible');
    }else{
      propertyDetailCtaFixed.classList.remove('visible');
    }
  }
};

// 物件詳細ギャラリー
const galleryImgs = document.querySelectorAll('.js-gallery');
const galleryWrapper = document.querySelector('#modal-gallery .p-modal-gallery__wrapper');
const galleryListWrapper = document.querySelector('#modal-gallery-list .p-modal-gallery-grid');
[].forEach.call(galleryImgs, (img) => {
  // スライド
  const slideSrc = img.getAttribute('data-gallery-image');
  const slideAlt = img.getAttribute('alt');
  const slide = document.createElement('img');
  if(slideSrc){
    slide.src = slideSrc;
    slide.alt = slideAlt;
    slide.width = 736;
    slide.height = 562;
    const slider = document.createElement('div');
    const caption = document.createElement('p');
    slider.classList.add('swiper-slide','p-modal-gallery__slide');
    caption.classList.add('p-modal-gallery__caption');
    caption.textContent = slideAlt;
    slider.appendChild(slide);
    slider.appendChild(caption);
    galleryWrapper.appendChild(slider);
  }
  // 画像一覧
  const imgElm = document.createElement('img');
  const listElm = document.createElement('li');
  const btnElm = document.createElement('button');
  imgElm.src = img.src;
  imgElm.alt = slideAlt;
  imgElm.width = 120;
  imgElm.height = 120;
  btnElm.setAttribute("data-micromodal-trigger", "modal-gallery");
  btnElm.appendChild(imgElm);
  listElm.appendChild(btnElm);
  galleryListWrapper.appendChild(listElm);
});

window.swiperGallery;

const trigger = document.querySelectorAll('[data-micromodal-trigger="modal-gallery"]');
const swiperGalleryObj = document.querySelector('#modal-gallery .js-swiper-gallery');

window.showGallery = () => {
  [].forEach.call(trigger, (btn, index) => {
    btn.addEventListener('click', (e) => {
      if(swiperGalleryObj !== null) {
        let initialSlide = index;
        if(initialSlide > galleryImgs.length) initialSlide = initialSlide - galleryImgs.length;
        window.swiperGallery = new Swiper ('#modal-gallery .js-swiper-gallery', {
          loop: true,
          slidesPerView: 1,
          initialSlide: initialSlide,
          spaceBetween: 0,
          navigation: {
            nextEl: "#modal-gallery .js-swiper-gallery .swiper-button-next",
            prevEl: "#modal-gallery .js-swiper-gallery .swiper-button-prev",
          },
          pagination: {
            el: "#modal-gallery .swiper-pagination",
            type: "fraction",
          }
        });
      }
    });
  });
}

window.closeGallery = () => {
  if(window.swiperGallery){
    window.swiperGallery.destroy(true, true);
    window.swiperGallery = null;
  }
}

// 物件詳細間取りギャラリー
const galleryPlanImgs = document.querySelectorAll('.js-gallery-plan');
const galleryPlanWrapper = document.querySelector('#modal-gallery-plan .p-modal-gallery__wrapper');

[].forEach.call(galleryPlanImgs, (img) => {
  const slideSrc = img.getAttribute('data-gallery-image');
  const slideAlt = img.getAttribute('alt');
  const slide = document.createElement('img');
  if(slideSrc){
    slide.src = slideSrc;
    slide.alt = slideAlt;
    slide.width = 736;
    slide.height = 562;
    const slider = document.createElement('div');
    const caption = document.createElement('p');
    slider.classList.add('swiper-slide','p-modal-gallery__slide');
    caption.classList.add('p-modal-gallery__caption');
    caption.textContent = slideAlt;
    slider.appendChild(slide);
    slider.appendChild(caption);
    galleryPlanWrapper.appendChild(slider);
  }
});

const triggerPlan = document.querySelector('[data-micromodal-trigger="modal-gallery-plan"]');
const swiperGalleryPlanObj = document.querySelector('#modal-gallery-plan .js-swiper-gallery');
if(triggerPlan !== null && swiperGalleryPlanObj !== null){
  window.swiperGalleryPlan = new Swiper ('#modal-gallery-plan .js-swiper-gallery', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
      nextEl: "#modal-gallery-plan .js-swiper-gallery .swiper-button-next",
      prevEl: "#modal-gallery-plan .js-swiper-gallery .swiper-button-prev",
    },
    pagination: {
      el: "#modal-gallery-plan .swiper-pagination",
      type: "fraction",
    }
  });
}

//フォームバリデート（資料請求）
window.validateRequestForm = () =>{
  // エラーメッセージ生成
  const createErrMsg = (target, msg) =>{
    target.classList.remove('error');
    const errMsg = document.createElement('p');
    errMsg.classList.add('c-form-error','u-mt-min');
    errMsg.textContent = msg;
    target.parentNode.insertBefore(errMsg, target.nextElementSibling);
    target.classList.add('error');
    target.focus();
  };

  // エラーメッセージ削除
  const removeErrMsg = (target) =>{
    const errElm = target.parentNode.querySelector('.c-form-error');
    if(errElm !== null) target.parentNode.removeChild(errElm);
  };

  // 郵便番号チェック
  const isPostalCode = (val) => {
    const regexp = /^\d{7}$/;
    if(regexp.test(val)) {
      return true;
    }
    return false;
  };

  //電話番号チェック
  const isTel = (val) =>{
    const regexp = /^0\d{9,10}$/;
    if(regexp.test(val)) {
      return true;
    }
    return false;
  };

  //メールアドレスチェック
  const isEmail = (val) =>{
    const regexp = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}.[A-Za-z0-9]{1,}$/;
    if(regexp.test(val)) {
      return true;
    }
    return false;
  };

  // お問い合わせ理由チェック
  const checkReason = (checkbox) => {
    let count = 0;
    [].forEach.call(checkbox, (el) => {
      if (el.checked) {
        count++;
      }
    });
    return count;
  };

  // 全入力チェック
  const allCheck = () => {
    const submitBtn = document.getElementById('request-submit');
    const required = document.querySelectorAll('[required]');
    let requiredCount = required.length;
    // if(requiredCheck.length > 0) requiredCount++;
    let completed = 0;
    if(document.getElementById('name').value != '') completed++;
    if(document.getElementById('kana').value != '') completed++;
    if(isPostalCode(document.getElementById('postal-code').value)) completed++;
    if(document.getElementById('address-level1').value != '') completed++;
    if(document.getElementById('address-level2').value != '') completed++;
    if(document.getElementById('address-level3').value != '') completed++;
    if(document.getElementById('address-current').value != '') completed++;
    if(isTel(document.getElementById('tel').value)) completed++;
    if(isEmail(document.getElementById('email').value)) completed++;
    if(completed == requiredCount) {
      submitBtn.classList.add('c-btn');
      submitBtn.classList.add('c-btn--lg');
      submitBtn.classList.remove('c-btn-disabled');
      submitBtn.classList.remove('c-btn-disabled--lg');
      submitBtn.removeAttribute('disabled');
    }else{
      submitBtn.classList.add('c-btn-disabled');
      submitBtn.classList.add('c-btn-disabled--lg');
      submitBtn.classList.remove('c-btn');
      submitBtn.classList.remove('c-btn--lg');
      submitBtn.setAttribute('disabled', true);
    }
  };

  //名前
  const namekanji = document.getElementById('name');
  if(namekanji !== null){
    namekanji.addEventListener('change', (e) => {
      removeErrMsg(e.currentTarget);
      if(e.currentTarget.value == ''){
        createErrMsg(e.currentTarget, '名前が未入力です');
      }
      allCheck();
    });
  }

  //フリガナ
  const namekana = document.getElementById('kana');
  if(namekana !== null){
    namekana.addEventListener('change', (e) => {
      removeErrMsg(e.currentTarget);
      if(e.currentTarget.value == ''){
        createErrMsg(e.currentTarget, 'フリガナが未入力です');
      }
      allCheck();
    });
  }

  //郵便番号
  const postalCode = document.getElementById('postal-code');
  if(postalCode !== null){
    postalCode.addEventListener('change', (e) => {
      removeErrMsg(e.currentTarget);
      if(!isPostalCode(postalCode.value)){
        createErrMsg(e.currentTarget, '郵便番号が未入力もしくは誤りがあります');
      }
    });
  };

  //住所
  const addressLevel1 = document.getElementById('address-level1');
  const addressLevel2 = document.getElementById('address-level2');
  const addressLevel3 = document.getElementById('address-level3');
  if(addressLevel1 !== null){
    addressLevel1.addEventListener('change', (e) => {
      removeErrMsg(e.currentTarget);
      if(e.currentTarget.value == ''){
        createErrMsg(e.currentTarget, '都道府県が未選択です');
      }
      allCheck();
    });
  }
  if(addressLevel2 !== null){
    addressLevel2.addEventListener('change', (e) => {
      removeErrMsg(e.currentTarget);
      if(e.currentTarget.value == ''){
        createErrMsg(e.currentTarget, '市区町村が未入力です');
      }
      allCheck();
    });
  }
  if(addressLevel3 !== null){
    addressLevel3.addEventListener('change', (e) => {
      removeErrMsg(e.currentTarget);
      if(e.currentTarget.value == ''){
        createErrMsg(e.currentTarget, '町名・番地が未入力です');
      }
      allCheck();
    });
  }

  //現在のお住まい
  const addressCurrent = document.getElementById('address-current');
  if(addressCurrent !== null){
    addressCurrent.addEventListener('change', (e) => {
      removeErrMsg(e.currentTarget);
      if(e.currentTarget.value == ''){
        createErrMsg(e.currentTarget, '現在のお住まいが未選択です');
      }
      allCheck();
    });
  }

  //電話番号
  const tel = document.getElementById('tel');
  if(tel !== null){
    tel.addEventListener('change', (e) => {
      removeErrMsg(e.currentTarget);
      if(!isTel(tel.value)){
        createErrMsg(e.currentTarget, '電話番号が未入力もしくは誤りがあります');
      }
      allCheck();
    });
  };

  //メールアドレス
  const email = document.getElementById('email');
  if(email !== null){
    email.addEventListener('change', (e) => {
      removeErrMsg(e.currentTarget);
      if(!isEmail(email.value)){
        createErrMsg(e.currentTarget, 'メールアドレスが未入力もしくは誤りがあります');
      }
      allCheck();
    });
  };

  // お問い合わせ理由
  // const requiredCheck = document.querySelectorAll('.required .c-form-check');
  // [].forEach.call(requiredCheck, (check) => {
  //   check.addEventListener('change', (e) => {
  //     removeErrMsg(e.currentTarget.closest('dd'));
  //     if(checkReason(requiredCheck) == 0){
  //       createErrMsg(e.currentTarget.closest('dd'), 'お問い合わせ理由が選択されていません');
  //     }
  //     allCheck();
  //   });
  // });
};

//フォームバリデート（ローンシミュレーション）
window.validateLoanForm = () =>{
  // エラーメッセージ生成
  const createErrMsg = (target, msg) =>{
    target.classList.remove('error');
    const errMsg = document.createElement('p');
    errMsg.classList.add('c-form-error','u-mt-min');
    errMsg.textContent = msg;
    target.parentNode.appendChild(errMsg);
    target.classList.add('error');
    target.focus();
  };

  // エラーメッセージ削除
  const removeErrMsg = (target) =>{
    const errElm = target.parentNode.querySelector('.c-form-error');
    if(errElm !== null) target.parentNode.removeChild(errElm);
  };

  // 数字チェック
  const isNumber = (val) => {
    const regexp1 = /^[0-9]+$/;
    const regexp2 = /^[0-9]+\.?[0-9]+$/;
    if(regexp1.test(val) || regexp2.test(val)) {
      return true;
    }
    return false;
  };

  // 全入力チェック
  const allCheck1 = () => {
    const formId = '#panel-loan-1';
    const submitBtn = document.getElementById('loan-submit1');
    const required = document.querySelectorAll(formId + ' [required]');
    let completed = 0;
    if(isNumber(document.getElementById('loan_month').value)) completed++;
    if(isNumber(document.getElementById('rate1').value)) completed++;
    if(isNumber(document.getElementById('years1').value)) completed++;
    if(document.getElementById('pref_cd').value != '') completed++;
    if(completed == required.length) {
      submitBtn.classList.add('c-btn-calc');
      submitBtn.classList.remove('c-btn-calc-disabled');
      submitBtn.removeAttribute('disabled');
    }else{
      submitBtn.classList.add('c-btn-calc-disabled');
      submitBtn.classList.remove('c-btn-calc');
      submitBtn.setAttribute('disabled', true);
    }
  };

  const allCheck2 = () => {
    const formId = '#panel-loan-2';
    const submitBtn = document.getElementById('loan-submit2');
    const required = document.querySelectorAll(formId + ' [required]');
    let completed = 0;
    if(isNumber(document.getElementById('price').value)) completed++;
    if(isNumber(document.getElementById('bonus').value)) completed++;
    if(isNumber(document.getElementById('rate2').value)) completed++;
    if(isNumber(document.getElementById('nensyu2').value)) completed++;
    if(completed == required.length) {
      submitBtn.classList.add('c-btn-calc');
      submitBtn.classList.remove('c-btn-calc-disabled');
      submitBtn.removeAttribute('disabled');
    }else{
      submitBtn.classList.add('c-btn-calc-disabled');
      submitBtn.classList.remove('c-btn-calc');
      submitBtn.setAttribute('disabled', true);
    }
  };

  //毎月返済額
  const loan_month = document.getElementById('loan_month');
  if(loan_month !== null){
    loan_month.addEventListener('change', (e) => {
      removeErrMsg(e.currentTarget);
      if(!isNumber(e.currentTarget.value)){
        createErrMsg(e.currentTarget, '毎月返済額が未入力です');
      }
      allCheck1();
    });
  }

  //金利
  const rate1 = document.getElementById('rate1');
  if(rate1 !== null){
    rate1.addEventListener('change', (e) => {
      removeErrMsg(e.currentTarget);
      if(!isNumber(e.currentTarget.value)){
        createErrMsg(e.currentTarget, '金利が未入力です');
      }
      allCheck1();
    });
  }

  //返済年数
  const years1 = document.getElementById('years1');
  if(years1 !== null){
    years1.addEventListener('change', (e) => {
      removeErrMsg(e.currentTarget);
      if(!isNumber(e.currentTarget.value)){
        createErrMsg(e.currentTarget, '返済年数が未入力です');
      }
      allCheck1();
    });
  }

  //ご希望のエリア
  const pref_cd = document.getElementById('pref_cd');
  if(pref_cd !== null){
    pref_cd.addEventListener('change', (e) => {
      removeErrMsg(e.currentTarget);
      if(e.currentTarget.value == ''){
        createErrMsg(e.currentTarget, 'ご希望のエリアが未選択です');
      }
      allCheck1();
    });
  }

  //購入希望価格
  const price = document.getElementById('price');
  if(price !== null){
    price.addEventListener('change', (e) => {
      removeErrMsg(e.currentTarget);
      if(!isNumber(e.currentTarget.value)){
        createErrMsg(e.currentTarget, '購入希望価格が未入力です');
      }
      allCheck2();
    });
  }

  //うちボーナス返済借入額
  const bonus = document.getElementById('bonus');
  if(bonus !== null){
    bonus.addEventListener('change', (e) => {
      removeErrMsg(e.currentTarget);
      if(!isNumber(e.currentTarget.value)){
        createErrMsg(e.currentTarget, 'うちボーナス返済借入額が未入力です');
      }
      allCheck2();
    });
  }

  //金利
  const rate2 = document.getElementById('rate2');
  if(rate2 !== null){
    rate2.addEventListener('change', (e) => {
      removeErrMsg(e.currentTarget);
      if(!isNumber(e.currentTarget.value)){
        createErrMsg(e.currentTarget, '金利が未入力です');
      }
      allCheck2();
    });
  }

  //返済年数
  const years2 = document.getElementById('years2');
  if(years2 !== null){
    years2.addEventListener('change', (e) => {
      removeErrMsg(e.currentTarget);
      if(!isNumber(e.currentTarget.value)){
        createErrMsg(e.currentTarget, '返済年数が未入力です');
      }
      allCheck2();
    });
  }

};

// メール・SNSシェア用にタイトルとURLを取得
const pageTitle = document.title;
const pageUrl = location.href;

//LINEの共有URLを設定
const lineUrl = encodeURI('https://line.me/R/msg/text/?' + pageUrl);

// SNSシェアポップアップ
const winOpen = (url) => {
  const newWin = window.open(url, 'sns-share', 'width=640, height=480, top=0, left=0, personalbar=0, toolbar=0, scrollbars=1, resizable=1');
  if(!newWin){
    location.href = url;
  }
};

// LINE
const lineBtn = document.querySelectorAll('.js-popup-line');
[].forEach.call(lineBtn, (btn) => {
  btn.addEventListener('click', (e) => {
    winOpen(lineUrl);
  });
});

// メールで送る
const mailBtn = document.querySelectorAll('.js-popup-mail');
[].forEach.call(mailBtn, (btn) => {
  btn.addEventListener('click', (e) => {
    location.href = 'mailto:?body=' + pageTitle + '%0D%0A' + pageUrl;
  });
});

// ページトップボタン
const pagetopBtn = document.querySelector('#pagetop');
const ctaFixed = document.querySelector('.js-cta-fixed');
if(ctaFixed !== null) pagetopBtn.classList.add('bottom-lg');

// ページトップへスクロール
const scrollToTop = () => {
  pagetopBtn.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });
};
scrollToTop();

// ページ内リンクスムーススクロール（指定IDへスクロール）
const scrollToId = () => {
  const anchorLinks = document.querySelectorAll('a[href^="#"]');
  [].forEach.call(anchorLinks, (link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      // 固定ヘッダーなどの固定要素がある場合はその分の高さを考慮
      // 固定要素のセレクタはコードに合わせて適宜変更
      const headerHeight = document.querySelector('header') !== null ? document.querySelector('header').clientHeight : 0;
      const targetId = link.hash;
      const targetElement = document.querySelector(targetId);
      const targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top - headerHeight;
      //const targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top;
      window.scrollTo({
        top: targetOffsetTop,
        behavior: "smooth"
      });
    });
  });
};
scrollToId();

// トップページでハッシュ指定がある場合は指定のタブを開く
window.initSearchTab = () =>{
  const tabId = location.hash.replace('#', '');
  if(!tabId){
    return;
  }

  let scrollId = 'top-search';
  let ctrl = null;
  let target = null;

  if(!window.matchMedia('(min-width: 768px)').matches){
    //ハンバーガーメニューを閉じる
    [].forEach.call(gnavPanel, (ctrl) => {
      ctrl.setAttribute('aria-hidden', true);
    });
    burger.setAttribute('aria-expanded', false);
    gnav.setAttribute('aria-hidden', true);
    document.documentElement.classList.remove('fixed');
  }

  if(window.matchMedia('(min-width: 1024px)').matches){
    ctrl = document.querySelector('[aria-controls="panel-' + tabId + '"]');
    target = document.getElementById('panel-' + tabId);
    if(ctrl !== null && target !== null){
      [].forEach.call(document.querySelectorAll('[role="tablist"] [role="tab"]'), (tab) => {
        tab.setAttribute("aria-selected", false);
      });
      [].forEach.call(document.querySelectorAll('[role="tabpanel"]'), (panel) => {
        panel.setAttribute("aria-hidden", true);
      });
      ctrl.setAttribute('aria-selected', true);
      target.setAttribute('aria-hidden', false);
    }
  }else{
    if(/area|line|map/.test(tabId)){
      ctrl = document.querySelector('[aria-controls="panel-' + tabId + '"]');
      target = document.getElementById('panel-' + tabId);
      if(ctrl !== null && target !== null){
        [].forEach.call(document.querySelectorAll('[role="tablist"] [role="tab"]'), (tab) => {
          tab.setAttribute("aria-selected", false);
        });
        [].forEach.call(document.querySelectorAll('[role="tabpanel"]'), (panel) => {
          panel.setAttribute("aria-hidden", true);
        });
        ctrl.setAttribute('aria-selected', true);
        target.setAttribute('aria-hidden', false);
      }
    }else if(/commute|budget/.test(tabId)){
      scrollId = tabId;
      ctrl = document.querySelector('[aria-controls="panel-sp-' + tabId + '"]');
      target = document.getElementById('panel-sp-' + tabId);
      console.log(ctrl.getAttribute('aria-expanded') + ' ' + target.getAttribute('aria-hidden'));
      if(ctrl !== null && target !== null){
        ctrl.setAttribute('aria-expanded', true);
        ctrl.setAttribute('aria-label', 'タブを閉じる');
        target.setAttribute('aria-hidden', false);
      }
    }
  }

  // 所定位置にスクロール
  const headerHeight = document.querySelector('header') !== null ? document.querySelector('header').clientHeight : 0;
  const targetOffsetTop = window.pageYOffset + document.getElementById(scrollId).getBoundingClientRect().top - headerHeight;
  window.scrollTo({
    top: targetOffsetTop,
    behavior: "smooth"
  });
};

// ハッシュ（ID）付きURLでロードされた場合
const loadScrollToId = () => {
  const targetId = location.hash;
  if(!targetId){
    return;
  }
  const targetElement = document.querySelector(targetId);
  if(targetElement === null){
    return;
  }
  const headerHeight = document.querySelector('header') !== null ? document.querySelector('header').clientHeight : 0;
  const targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top - headerHeight;
  window.scrollTo({
    top: targetOffsetTop,
    behavior: "smooth"
  });
};

// スクロール量取得
const getScrolled = () => {
  return (window.pageYOffset !== undefined) ? window.pageYOffset: document.documentElement.scrollTop;
}

// Dom読み込み時実行
// document.addEventListener('DOMContentLoaded', () => {
// });

// コンテンツ読み込み完了後に実行
window.addEventListener('load', () => {
  // ハッシュ付きURLの場合の位置変更
  loadScrollToId();

  //フェードインアニメーション
  const animElement = document.querySelectorAll('.js-effect-fadein');
  const animElementArr = Array.prototype.slice.call(animElement);
  const animElement2 = document.querySelectorAll('.js-effect-fadein-right');
  const animElementArr2 = Array.prototype.slice.call(animElement2);
  const animElement3 = document.querySelectorAll('.js-effect-fadein-left');
  const animElementArr3 = Array.prototype.slice.call(animElement3);

  const fadeinObserver = (entries, observer) => {
    [].forEach.call(entries, (entry) => {
      if(entry.isIntersecting) {
        entry.target.classList.add('inview');
        observer.unobserve(entry.target);
      }
    });
  }
  const options = {
    rootMargin: "-100px 0px"
  }
  const io = new IntersectionObserver(fadeinObserver, options);
  io.POLL_INTERVAL = 100;
  [].forEach.call(animElementArr, (el) => {
    io.observe(el);
  });
  [].forEach.call(animElementArr2, (el) => {
    io.observe(el);
  });
  [].forEach.call(animElementArr3, (el) => {
    io.observe(el);
  });
});

// スクロール時実行
window.addEventListener("scroll", () => {
  const header = document.querySelector('.l-header');
  if(getScrolled() > 100){
    if(header !== null) header.classList.add('fixed');
    pagetopBtn.classList.add('visible');
  }else{
    if(header !== null) header.classList.remove('fixed');
    pagetopBtn.classList.remove('visible');
  }
});
